import AddRewardPageContainer from "./add-reward.container";

export default AddRewardPageContainer;